import React from 'react';
import { InputNumber as AntInputNumber } from 'antd';
import type { InputNumberProps } from 'antd';
import clsx from 'clsx';

type ValueType = string | number;

/**
 * Thin wrapper over the Antd InputNumber (per the antd wrapper standardization plan):
 * single import source through @common/components and a `wk-input-number` class hook.
 * Generic on the value type so callers can narrow to `number` and keep their existing onChange signatures.
 */
export const InputNumber = <T extends ValueType = ValueType>({
  className,
  ...props
}: InputNumberProps<T>) => (
  <AntInputNumber<T>
    {...props}
    className={clsx('wk-input-number', className)}
  />
);
